<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="400px")
    v-card
      v-card-title.pb-0.mb-0.px-5.white.text-center.align-center
        v-row(no-gutters)
          v-col.text-center
            h6.my-4.text-center {{ $t('change_email_address_for') }}
      v-card-text.pa-0
        v-form.pa-4(ref="form")
          v-col.pb-0(cols="12")
            p.mb-3.label.basic600--text.text-uppercase {{ $t('current_email_address') }}
            v-text-field.s1.basic500--text( solo flat background-color="basic400"    height="40" v-model="currentEmail" label="Current e-mail address"  disabled outlined dense)
          v-col.py-0(cols="12")
            p.mb-3.label.basic600--text.text-uppercase {{ $t('new_email_address') }}
            v-text-field.s1.basic800--text(solo flat background-color="basic200"    height="40" v-model="form.email" label="New e-mail address" :rules="rules.email" outlined dense)
              template(v-slot:label)
                  .p1.basic600--text {{ $t('enter_new_email_address') }}
          v-col.py-0.mb-n5.mt-n3(cols="12")
            v-row
              v-col.grow.pr-0(style="margin-right:-2px")
                p.mb-3.label.basic600--text.text-uppercase {{ $t('confirmation_code') }}
                v-text-field(solo flat background-color="basic200"    height="40" v-model="form.code" outlined dense label="Confirmation code" :rules="rules.code"  style="border-top-right-radius:0px; border-bottom-right-radius:0px")
                  template(v-slot:label)
                    .p1.basic600--text {{ $t('six_digit_code') }}
              v-col.shrink.pl-0
                p.mb-3.label.white--text.text-uppercase {{ $t('new') }}
                v-btn.white--text.button-AA-medium.info500(:disabled="codeTimer > 0" @click="requestCode" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px;") {{ codeTimer <= 0 ? 'Request' : `Request (${codeTimer})` }}
        v-divider
        v-card-actions
          v-spacer
          v-btn.button-AA-medium(color='grey' :loading="loading" text @click='closeModal')
            | {{ $t('cancel') }}
          v-btn.white--text.button-AA-medium.info500(color='info500' :loading="loading" depressed height=32 @click="changeEmail")
            | {{ $t('save') }}
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'ChangeEmail',
  props: ['showModal'],
  data: () => ({
    loading: false,
    currentEmail: '',
    form: {
      email: '',
      code: '',
    },
    codeTimer: 0,
    rules: {
      email: [
        v => !!v || 'New e-mail address is required',
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      code: [
        v => !!v || 'Confirmation code is required'
      ],
    }
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      lang: 'language/getLanguage'
    }),
  },
  watch: {
    showModal (val) {
      this.$emit('update:showModal', val)
      if (val) {
        this.$refs.form.reset()
      }
    },
    user: {
      deep: true,
      handler (val) {
        this.currentEmail= val.email
      }
    }
  },
  mounted () {
    this.currentEmail = this.user.email
  },
  methods: {
    ...mapActions(['showMessage']),
    requestCode () {
      if (!this.form.email) {
        this.showMessage(['error', this.$t('error_message.enter_new_email')])
        return
      }
      this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.form.email)}`)
          .then(resp => {
            if (resp.data.available) {
              this.$axios.post('/users/send_verification_code/', { email: this.form.email, language: this.lang })
                  .then(() => {
                    this.showMessage(['info', this.$t('info_message.confirmation_code_sent_to', { text: this.form.email })])
                    this.codeTimer = 30
                    const timer = setInterval(() => {
                      this.codeTimer--
                      if (this.codeTimer <= 0) {
                        clearInterval(timer)
                      }
                    }, 1000)
                  })
                  .catch(() => {
                    this.showMessage(['error', this.$t('error_message.unable_to_send_confirmation')])
                  })
            } else {
              this.showMessage(['error', `${this.form.email} is already tied to different account`])
            }
          })
          .catch(() => {})
    },
    changeEmail () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      this.$axios.patch(`/users/${this.user.id}/`, this.form)
          .then(resp => {
            this.$store.commit('user/setUser', resp.data)
            this.showMessage(['success', this.$t('success_message.email_successfully_updated')])
            this.closeModal()
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.invalid_confirmation_code')])
          })
          .finally(() => {
            this.loading = false
          })
    },
    closeModal () {
      this.$emit('update:showModal', false)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "change_email_address_for": "Change email address for sign in",
    "current_email_address": "Current Email address",
    "new_email_address": "New Email Address",
    "enter_new_email_address": "Enter New Email Address"
  },
  "id": {
    "change_email_address_for": "tukar email untuk Log in",
    "current_email_address": "email sekarang",
    "new_email_address": "email baru",
    "enter_new_email_address": "Isi email baru"
  }
}
</i18n>